import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import { Typography } from "@mui/material";
import axios from "axios";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";

const BranchMultiSelect = ({
    onChange,
    value,
    label,
    setFieldValue,
    instituteDetails
}) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const isBranchAdmin = localStorage.getItem("branchAdmin") === "true";
    const BranchId = localStorage.getItem("branchId");

    const RequestId = useRequestIdGenerater();
    const { rendomRequestId, generateTimeStamp } = useTimeStamp();

    const fetchBranchList = async () => {
        try {
            const response = await axios.get(`/v1/institute-branch/page?pageNumber=0&pageSize=100`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId
                    ),
                },
            });
            const data = response?.data?.data?.content;
            if (isBranchAdmin && BranchId !== null) {
                const filteredBranch = data?.filter((item) => item?.id === BranchId);
                setBranchList(filteredBranch);
            } else {
                setBranchList(data);
            }


            generateTimeStamp();
        } catch (error) {
            generateTimeStamp();
            if (!error.response) {
                dispatch(openSnackbar({ message: error.message, type: "error" }));
            } else {
                dispatch(
                    openSnackbar({ message: error.response.data.Msg, type: "error" })
                );
            }
        }
    };

    useEffect(() => {
        fetchBranchList();
    }, []);

    useEffect(() => {
        if (branchList.length > 0 && value) {
            const selected = branchList.filter((batch) => value.includes(batch.id));
            setSelectedItems(selected);

            if (!instituteDetails?.branchEnabled) {
                setFieldValue("eventForIds", selected.map((batch) => batch.id));
            } else {
                setFieldValue("eventForBranchIds", selected.map((batch) => batch.id));
            }
        }
    }, [branchList, value, setFieldValue, instituteDetails]);

    const handleCheckboxChange = (event, option) => {
        const selectedIndex = selectedItems.findIndex(
            (item) => item.id === option.id
        );

        let newSelectedItems;
        if (selectedIndex === -1) {
            newSelectedItems = [...selectedItems, option];
        } else {
            newSelectedItems = selectedItems.filter((item) => item.id !== option.id);
        }

        setSelectedItems(newSelectedItems);

        if (onChange) {
            onChange(newSelectedItems.map((item) => item.id));
        }

        if (!instituteDetails?.branchEnabled) {
            setFieldValue("eventForIds", newSelectedItems.map((item) => item.id));
        } else {
            setFieldValue("eventForBranchIds", newSelectedItems.map((item) => item.id));
        }
    };


    const renderOption = (props, option) => (
        <li {...props}>
            <Checkbox
                checked={selectedItems.some((item) => item.id === option.id)}
                onChange={(event) => handleCheckboxChange(event, option)}
            />
            <Typography>{option.name}</Typography>
        </li>
    );

    useEffect(() => {
        generateTimeStamp();
    }, []);

    return (
        <Autocomplete
            multiple
            id="batch-multi-select"
            options={branchList}
            disableCloseOnSelect
            value={selectedItems}
            onChange={(_, newValue) => {
                setSelectedItems(newValue);
                if (onChange) {
                    onChange(newValue.map((item) => item.id));
                }
                if (!instituteDetails?.branchEnabled) {
                    setFieldValue("eventForIds", newValue.map((item) => item.id));
                } else {
                    setFieldValue("eventForBranchIds", newValue.map((item) => item.id));
                }
            }}

            getOptionLabel={(option) => option.name}
            renderOption={renderOption}
            renderInput={(params) => (
                <TextField {...params} variant="outlined" label={label || "Branch"} />
            )}
        />
    );
};

BranchMultiSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.array,
    label: PropTypes.string,
    setFieldValue: PropTypes.func.isRequired,
};

export default BranchMultiSelect;
